export default __webpack_public_path__ + "static/media/loading.eb08dd1d.gif";